<template>
  <span class="credentials-menu" v-click-outside="closeMenu">
    <div class="action" v-on:click="emitDeleteCredsPopup" v-on:focusout="closeMenu">מחיקת חשבון</div>
    <div class="divider"/>
    <div class="action" v-on:click="emitUpdateCredsPopup" v-on:focusout="closeMenu">עריכת שם</div>
    <div v-if="isOpenBanking">
      <div class="divider"/>
      <div class="renew">
        <div class="action" v-on:click="renewConsent" v-on:focusout="closeMenu">{{ consentRenewal }}</div>
        <div v-if="isLoading" class="creds-spinner-wrapper">
          <spinner class="loader" :src="require('@/assets/onboarding/spinner-big.svg')"/>
        </div>
        <img v-else :src="require('@/assets/obk-arrow.svg')">
      </div>
    </div>
  </span>
</template>

<script>
import Segment from '@/Segment';
import ClickOutside from '@/directives/click-outside';
import { mapActions } from 'vuex';
import DeleteCredsPopup from '@/base-components/credentials/credentials-list/DeleteCredsPopup';
import UpdateCredsNamePopup from '@/base-components/credentials/credentials-list/UpdateCredsNamePopup';
import AggregatorApi from '@/api/AggregatorApi';
import DDLogs from '@/DDLogs';
import Spinner from '@/base-components/onboarding/Spinner';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow';
import AgentsUtls from '@/utils/agentsUtils';

export default {
  name: 'CredentialsMenu',
  directives: {
    ClickOutside,
  },
  components: {
    Spinner,
  },
  props: {
    closeMenu: {
      type: Function,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    isOpenBanking() {
      return this.source && !!this.source.openBankingConsentId;
    },
    consentRenewal() {
      return `לחידוש ההסכמה ב${this.sourceName}`;
    },
    sourceName() {
      return this.source.sourceName === 'לאומי קארד' ? 'מקס' : this.source.sourceName;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    async renewConsent() {
      if (this.source.openBanking.allowDesktop === false && !AgentsUtls.isMobile()) {
        this.openModal({
          component: AddCredentialsFlow,
          props: {
            sourceNameToAdd: this.source.sourceName,
          },
          popupAlignment: 'full-screen',
        });
        Segment.trackUserInteraction('RenewConsentOBKClickedFormNotAllowedDesktop',
          { credentialsId: this.source.credentialsId, source: this.source.sourceName });
      } else {
        this.isLoading = true;
        Segment.trackUserInteraction('RenewConsentOBKClicked', {
          credentialsId: this.source.credentialsId,
          source: this.source.sourceName,
        });
        const url = await AggregatorApi.updateConsent(
          this.source.openBanking.aggregatorBankId,
          this.source.openBankingConsentId,
          this.source.credentialsId,
        );
        DDLogs.log('Redirecting to OpenBanking', { url });
        window.location.href = url;
      }
    },
    emitDeleteCredsPopup() {
      Segment.trackUserInteraction('SectionMenu_DeleteCredsClicked');
      this.openModal({
        component: DeleteCredsPopup,
        props: { source: this.source },
      });
    },
    emitUpdateCredsPopup() {
      Segment.trackUserInteraction('SectionMenu_UpdateCredsClicked');
      this.openModal({
        component: UpdateCredsNamePopup,
        props: { source: this.source },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';

  .credentials-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 13px;
    top: 12px;
    border-radius: 1px;
    background-color: $riseup_white;
    box-shadow: 2px 2px 8px 0 $riseup_gray_0;

    .action {
      display: flex;
      align-items: center;
      font-family: SimplerPro;
      font-size: 14px;
      padding: 0 8px;
      height: 30px;
      width: 100%;
      cursor: pointer;
      margin: 5px 0;
    }

    .divider {
      height: 1px;
      background: $riseup_gray_0;
    }
    .renew {
      display: flex;
      padding-left: 5px;
      .creds-spinner-wrapper {
        padding-top: 10px;
        .loader img.spinner {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
</style>
